import { Action } from '@ngrx/store';
import { ContactPersonRole } from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/contact-person-role.model';

export enum ActionTypes {
  INIT = '[Bulk CEM UL Modify Contact Person] Init',
  SET_NAME = '[Bulk CEM UL Modify Contact Person] Set Name',
  SET_COUNTRY_AREA_CODE = '[Bulk CEM UL Modify Contact Person] Set Country Area Code',
  SET_PHONE = '[Bulk CEM UL Modify Contact Person] Set Phone',
  SET_EXTENSION = '[Bulk CEM UL Modify Contact Person] Set Extension',
  SET_EMAIL = '[Bulk CEM UL Modify Contact Person] Set Email',
  ADD_CONTACT = '[Bulk CEM UL Modify Contact Person] Add Contact',
  ADD_CONTACT_FAILURE = '[Bulk CEM UL Modify Contact Person] Add Contact Failure',
  CLEAR = '[Bulk CEM UL Modify Contact Person] Clear',
  FETCH_ROLES = '[Bulk CEM UL Modify Contact Person] Fetch Roles',
  STORE_ROLES = '[Bulk CEM UL Modify Contact Person] Store Roles',
  CLEAR_ROLES = '[Bulk CEM UL Modify Contact Person] Clear Roles',
  SET_ROLE = '[Bulk CEM UL Modify Contact Person] Set Role',
}

export class Init implements Action {
  readonly type: string = ActionTypes.INIT;
  constructor(public payload?: any) {}
}

export class SetName implements Action {
  readonly type: string = ActionTypes.SET_NAME;
  constructor(public payload: string) {}
}

export class SetRole implements Action {
  readonly type: string = ActionTypes.SET_ROLE;
  constructor(public payload: number) {}
}

export class SetCountryAreaCode implements Action {
  readonly type: string = ActionTypes.SET_COUNTRY_AREA_CODE;
  constructor(public payload: string) {}
}

export class SetPhone implements Action {
  readonly type: string = ActionTypes.SET_PHONE;
  constructor(public payload: string) {}
}

export class SetExtension implements Action {
  readonly type: string = ActionTypes.SET_EXTENSION;
  constructor(public payload: string) {}
}

export class SetEmail implements Action {
  readonly type: string = ActionTypes.SET_EMAIL;
  constructor(public payload: string) {}
}

export class AddContact implements Action {
  readonly type: string = ActionTypes.ADD_CONTACT;
  constructor(public payload?: any) {}
}

export class AddContactFailure implements Action {
  readonly type: string = ActionTypes.ADD_CONTACT_FAILURE;
  constructor(public payload?: any) {}
}

export class Clear implements Action {
  readonly type: string = ActionTypes.CLEAR;
  constructor(public payload?: any) {}
}

export class FetchRoles implements Action {
  readonly type: string = ActionTypes.FETCH_ROLES;
  constructor(public payload?: any) {}
}

export class StoreRoles implements Action {
  readonly type: string = ActionTypes.STORE_ROLES;
  constructor(public payload: ContactPersonRole[]) {}
}

export type Actions =
  | Init
  | SetName
  | SetRole
  | SetCountryAreaCode
  | SetPhone
  | SetExtension
  | SetEmail
  | AddContact
  | AddContactFailure
  | Clear
  | FetchRoles
  | StoreRoles;
